import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=23a3937c&scoped=true&"
import script from "./Download.vue?vue&type=script&lang=ts&"
export * from "./Download.vue?vue&type=script&lang=ts&"
import style0 from "./Download.vue?vue&type=style&index=0&id=23a3937c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a3937c",
  null
  
)

export default component.exports